import * as React from 'react';

import PillTag from 'bundles/discussions/components/forumsV2-PillTag';

import _t from 'i18n!nls/discussions';

import type { AnswerBadgeProps } from './__types__';

const acceptedTopLevelBadges = {
  MENTOR: true,
  TEACHING_STAFF: true,
  COURSE_ASSISTANT: true,
  UNIVERSITY_ADMIN: true,
  INSTRUCTOR: true,
  DATA_COORDINATOR: true,
  LEARNER: true,
  NOT_ENROLLED: true,
};

export function badgeLabels() {
  return {
    MENTOR: _t('Mentor'),
    TEACHING_STAFF: _t('Staff'),
    COURSE_ASSISTANT: _t('Assistant'),
    UNIVERSITY_ADMIN: _t('Staff'),
    INSTRUCTOR: _t('Instructor'),
    DATA_COORDINATOR: _t('Staff'),
    LEARNER: _t('Learner'),
    NOT_ENROLLED: _t('Unenrolled'),
  };
}

export default function AnswerBadge({ answerBadge }: AnswerBadgeProps) {
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (acceptedTopLevelBadges[answerBadge]) {
    const labelsMap = badgeLabels();
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return <PillTag label={labelsMap[answerBadge]} badge={answerBadge} />;
  } else {
    return null;
  }
}
